import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import toast from "react-hot-toast";
import api from "../services/api";

interface SocketContextProps {
  lockedRows: any[];
  kickedRows: any[];
  addLockedRow: (data: any) => void;
  removeLockedRow: (data: any) => void;
  resetLockedRows: () => void;
  handleKick: (data: any) => void;
}

const SocketContext = createContext<SocketContextProps | undefined>(undefined);
interface SocketProviderProps {
  schema: any;
  children: any;
  onKick: (data: any) => void;
  subSchema?: any;
  onNewMessage?: (groupId: number) => void;
}
export const SocketProvider: React.FC<SocketProviderProps> = ({ children, schema, onKick, subSchema, onNewMessage }) => {
  const [lockedRows, setLockedRows] = useState<any[]>([]);
  const [kickedRows, setKickedRows] = useState<any[]>([]);


  useEffect(() => {

    const loadInitialLockedRows = async () => {
      try {
        const searchParams = new URLSearchParams({
          view_table: schema?.viewTable,
          url_path: schema.client.urlPath,
        });
       /* api.get(`/locks-by-table`, searchParams).then((result: any) => {

        });*/
      } catch (error) {
        console.error('Error fetching initial messages:', error);
      }
    };

    loadInitialLockedRows();
  }, []);

  useEffect(() => {
    const socket = io('https://socket-zoe.stagemporium.com');
/*
    socket.on('connect', () => {
      console.log('✅ Connected to the server');
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from the server');
    });

    socket.on('connect_error', (error:any) => {
      console.log('Connection error:', error);
    });*/

    // Lock event
    socket.on('lock', (data:any) => {
      if (
        data.table === schema?.viewTable
        ||
        data.table === subSchema?.viewTable
      ) {
        setLockedRows((prev) => [...prev, data?.data]);
      }
    });

    // Unlock event
    socket.on('unlock', (data:any) => {
      if (
        data.table === schema?.viewTable
        ||
        data.table === subSchema?.viewTable
      ) {
        if (Array.isArray(data.data)) {
          setLockedRows((prevLockedRows) =>
             prevLockedRows.filter(
                (row) => !data.data.some((item: any) => item.relation_id == row.relation_id)
              )
          );
        } else {
          setLockedRows((prevLockedRows) =>
            prevLockedRows.filter((row) => row.relation_id != data.data?.relation_id)
          );
        }
      }
    });

    // New chat message event
    socket.on('message', (data: any) => {
      if (data.table === 'groups' && data?.data?.group_id && onNewMessage) {
        onNewMessage(data.data.group_id);
      }
    });

    // Kick event
    socket.on('kick', (data:any) => {
      if (
        data.table === schema?.viewTable
        ||
        data.table === subSchema?.viewTable
      ) {
        setKickedRows((prev) => [...prev, data?.data]);
        handleKick(data);
        onKick(data);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  // Függvények az adatok kezelésére
  const addLockedRow = (data: any) => setLockedRows((prev) => [...prev, data]);
  const removeLockedRow = (data: any) =>
    setLockedRows((prevLockedRows) =>
      prevLockedRows.filter((row) => row.relation_id !== data?.relation_id)
    );
  const resetLockedRows = () => setLockedRows([]);
  const handleKick = (data: any) => {
    toast(`${data?.data?.kick_user?.name} has kicked you out from editing the row.`, {
      icon: '👋🏽',
    });

    if (subSchema && data?.table !== 'groups'){
      subSchema.client
        .deleteLock(data?.relation_id, {
          schema: JSON.stringify(subSchema.client),
          view_table: subSchema.viewTable,
        })
        .then((result: any) => {
        });
    }else{
      schema.client
        .deleteLock(data?.relation_id, {
          schema: JSON.stringify(schema.client),
          view_table: schema.viewTable,
        })
        .then((result: any) => {
        });
    }
  };

  return (
    <SocketContext.Provider
      value={{
        lockedRows,
        kickedRows,
        addLockedRow,
        removeLockedRow,
        resetLockedRows,
        handleKick,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

// Context használata egyszerű hookon keresztül
export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocketContext must be used within a SocketProvider');
  }
  return context;
};
